import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { formatDate } from 'Util';
import SubHead from 'Component/title/sub_head';
import RelativeRateChart from 'Component/chart/relative_rate';

const RelativeRate = () => {

  const { relativeRate } = useSelector((state) => state.stock);
  const [data, setData] = useState();

  useEffect(() => {
    if (relativeRate && relativeRate.relativeRate) {
      const x = [];
      const y1 = [];
      const y2 = [];

      let list = [...relativeRate.relativeRate];

      list.forEach(element => {
        x.push(formatDate(element.TRD_DT));
        y1.push(element.COMPOUND_RATE.toFixed(2));
        y2.push(element.BENCHMARK.toFixed(2));
      });

      setData({
        x: x,
        y1: y1,
        y2: y2
      });
    } else {
      setData(null);
    }
  }, [relativeRate]);

	return (
    <div className="content7">
      <SubHead>
        <img src="/static/images/icon_heart2.svg" alt="" />
        <span>시장대비 상대수익률</span>
      </SubHead>
      <div className="cont chartarea">
        <div className="chart chart1" style={{ display: "block" }}>
          { data && relativeRate &&
            <RelativeRateChart data={data} title={[relativeRate.stkNmKor, relativeRate.mktTyp]} />
          }
        </div>
      </div>
    </div>
  );
}

export default RelativeRate;
